<template>
  <page>
  
    <head-nav :title="$t('language.teacher_talks')">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

    <scroll-page :pull-reload="false">
     
      <render-slots v-for="(talk,index) in talks" :key="index" :talk="talk" @RELOAD_TALKS="getTalks"/>
    </scroll-page>
    
  </page>

</template>

<script>

// listing the specific group talk with its slots.


import RenderSlots from '../components/talks/RenderSlots.vue';
import ScrollPage from '../components/ScrollPage.vue';

//import PagePadding from '../components/PagePadding.vue';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import IconButtonBack from '../components/buttons/IconButtonBack';

export default {
  name: 'group-talks-page',
  data:function(){
    return {
      group_id:this.$route.params.id,
      talk_id:this.$route.params.talk_id,
      talks:[],
    }
  },
  methods:{
    getTalks(){
     
    
   // this.loading=true;

      var payload={
        group_id:this.group_id,
        talk_id:this.talk_id,
      }
    this.$store.dispatch('get_teacher_talks',payload).then(result=>{
      if(result.data.length==0){
        return;
      }else{
       if(result.data.length>1){
         alert('expecting only 1 result')
       }
       this.talks=result.data;
       
      }

    })
    },
  },
  computed:{
  },
  components:{
    ScrollPage,
    RenderSlots,
    //PagePadding,
    Page,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
  },
  created(){
  },
  mounted(){
    // lets get the talks..
  this.getTalks();
  },
  beforeDestroy(){
  }
  
  
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
